import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const gandi = defineConnector({
  identifier: "gandi",
  name: "Gandi",
  tagLine: "Domain registration and web hosting",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://api\\.gandi\\.net/.*",
  auth: (app) => bearerAuth(app.secret.personalAccessToken),
  steps: [
    {
      title: "Create a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [**Account settings > Personal access tokens**](https://admin.gandi.net/organizations/account/pat) in the Gandi admin, select an organization, click **Create a token**, and choose the scopes you need.",
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "personalAccessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.gandi.net/v5/organization/user-info",
  },
});
